export enum JobStatus {
  FINISHED = "finished",
  STARTED = "started",
  FAILED = "failed",
}
